import moment from 'moment';
import { find } from 'lodash';

const _ = { find };

// Conversations fetched per page for the inbox's cursor pagination. Kept alongside
// the messaging helpers so the action and the Inbox page share one source of truth.
export const CONVERSATION_PAGE_SIZE = 50;

export function convHasUnreadMessages(conv) {
    return (conv.messages[0] && !conv.messages[0].isOutbound && moment(conv.messages[0].created).isAfter(conv.lastRead));
}

// Unresolved ids string-coerce to the literal "undefined" and get persisted server-side.
export const isValidEntityId = (id) => {
    if (id === null || id === undefined || id === '') {
        return false;
    }
    const numeric = Number(id);
    return Number.isInteger(numeric) && numeric > 0;
};

export const getMemberEntityObject = (types, memberId, memberContextTypeId) => {
    return {
        entityId: memberId,
        entityType: 'member',
        entityContext: _.find(types.messagingMemberContextType, { id: memberContextTypeId }).value,
    };
};

export const MemberContextTypes = {
    EVENT_PARTCIPANT: 1,
    EVENT_ORGANIZER: 2,
    CLUB_ORGANIZER: 3,
    CLUB_MEMBER: 4,
    PLAYER: 5,
    COLLEGE_RECRUITER: 6,
    COLLEGE_RECRUIT: 7,
};

export const ConversationContextTypes = {
    EVENT_PROFILE: 1,
    CLUB_PROFILE: 2,
    PLAYER_PROFILE: 3,
    INBOX: 4,
    COLLEGE_RECRUIT_SEARCH: 5,
};
